<template>
    <div class="bar-container" :class="{ 'show-divider': showYearDivider }">
        <a
            class="chart-bar"
            :class="{
                active: active,
                edited: data.edited,
                empty: !data.final && !data.edited,
                negative: data.bonus < 0 || data.expectedBonus < 0
            }"
            @click="selectBar"
        >
            <div class="chart-bar-amount">
                <div class="chart-bar-amount-wrapper">
                    <span
                        :style="{ height: expHeight + 'px' }"
                        :class="{
                            fullwidth: !bHeight && !data.final,
                            negative: data.expectedBonus < 0
                        }"
                        class="expected"
                    />
                    <span
                        :style="{ height: bHeight + 'px' }"
                        :class="{ negative: data.bonus < 0 }"
                    />
                </div>
            </div>
            <div class="chart-bar-month">{{ monthName }}</div>
        </a>
        <RockChartBarYear
            v-if="showYearDivider"
            :year="year"
            class="bar-divider"
        />
    </div>
</template>
<script>
import EventBus from '@/shared/VueEvent';
import RockChartBarYear from '@/components/RockChartBarYear';

export default {
    components: {
        RockChartBarYear
    },
    props: {
        data: Object,
        max: Number,
        min: Number,
        active: Boolean,
        showYearDivider: Boolean,
        year: String
    },
    data() {
        return {
            bHeight: 0,
            expHeight: 0
        };
    },
    computed: {
        barHeight: function () {
            const min = this.min < 0 ? this.min * -1 : 0;
            const max = Math.max(this.max, min);
            const val =
                this.data.bonus < 0 ? this.data.bonus * -1 : this.data.bonus;
            return Math.round((val / max) * 200);
        },
        negBarHeight: function () {
            return this.data.bonus < 0 ? -1 * this.barHeight : 0;
        },
        expectedBarHeight: function () {
            const min = this.min < 0 ? this.min * -1 : 0;
            const max = Math.max(this.max, min);
            const val =
                this.data.expectedBonus < 0
                    ? this.data.expectedBonus * -1
                    : this.data.expectedBonus;
            return Math.round((val / max) * 200);
        },
        expectedNegBarHeight: function () {
            return this.data.expectedBonus < 0
                ? -1 * this.expectedBarHeight
                : 0;
        },
        monthName: function () {
            if (this.data.month >= 1 && this.data.month <= 12) {
                const monthNames = [
                    'Jan',
                    'Feb',
                    'Mrt',
                    'Apr',
                    'Mei',
                    'Jun',
                    'Jul',
                    'Aug',
                    'Sep',
                    'Okt',
                    'Nov',
                    'Dec'
                ];
                return monthNames[this.data.month - 1];
            }
            return '';
        }
    },
    mounted() {
        const _this = this;
        this.bHeight = 0;
        this.expHeight = 0;
        setTimeout(function () {
            _this.bHeight = _this.barHeight;
            _this.expHeight = _this.expectedBarHeight;
        }, Math.round(Math.random() * 1000));
    },
    methods: {
        selectBar: function () {
            EventBus.fire('selectBonus', this.data);
        }
    }
};
</script>
